export const SunLogo = ({ size = 40 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-label="1st Nations Security sun logo"
    role="img"
    data-testid="sun-logo"
  >
    <g>
      {[0, 30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330].map((deg) => (
        <path
          key={deg}
          d="M50 2 L56 22 L44 22 Z"
          fill="#FFC107"
          transform={`rotate(${deg} 50 50)`}
        />
      ))}
      <circle cx="50" cy="50" r="27" fill="#FF9100" />
      <circle cx="50" cy="50" r="19" fill="#FF5500" opacity="0.85" />
    </g>
  </svg>
);
